export enum SwipeType {
  NONE = '',
  FULL = 'full-screen'
}
